<template>
  <div>
 <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
  <el-breadcrumb-item>首页轮播管理</el-breadcrumb-item>
</el-breadcrumb>

<el-card>
    <!-- 搜索区域 -->
<el-row>
  <el-col :span="6">
  <div>
  
</div>
</el-col>
  <el-col :span="6">
  <el-button type="primary" @click="insertHomes" >
添加轮播
  </el-button></el-col>
</el-row>
 <el-table
    :data="homeList"
     border
    style="width: 100%">
    <!-- <el-table-column
    label="序号"
     type="index"
     width="50"
     >
    </el-table-column> -->
       <el-table-column
      prop="homPageCreateDate"
      label="时间"
      width="180">
    </el-table-column>
    <el-table-column
      prop="homPageTitle"
      label="标题"
      width="180">
    </el-table-column>
    <el-table-column
      prop="homPageContent"
      :show-overflow-tooltip="true"
      label="描述"
      width="180">
    </el-table-column>
        <el-table-column
      prop="homPageRouter"
      :show-overflow-tooltip="true"
      label="路由"
      width="180">
    </el-table-column>

    <el-table-column
      label="是否显示" 
      width="120">
      <!-- 卡槽 -->
      <template slot-scope="scope">
<el-switch
  v-model="scope.row.isShow" @change="HomeShow(scope.row)">
</el-switch>
</template>
    </el-table-column>

    <el-table-column
      label="操作"
      width="190"
     >
      <template slot-scope="scope">
<!-- <el-button   size="small" @click="updateNew(scope.row)"  ><svg class="icon" aria-hidden="true"><use xlink:href="#icon-xiugai"></use></svg></el-button> -->
<el-button   size="small" @click="deleteHomePage(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></el-button>
   <el-button  @click="updatHomePage(scope.row)"  ><svg class="icon" aria-hidden="true"><use xlink:href="#icon-xiugai"></use></svg></el-button>
      </template>
    </el-table-column>
  </el-table>



</el-card>
<!-- 弹窗 -->
<el-dialog
  title="首页轮播添加"
  :visible.sync="insertHome"
  width="50%"
  center
  >
  <!-- 主体区域 -->
  <el-form ref="addHomePageRef" :model="addHomePageForm" :rules="addHomePageRules" label-width="80px">
  <el-form-item label="标题" prop="homPageTitle">
    <el-input v-model="addHomePageForm.homPageTitle"></el-input>
  </el-form-item>
  <el-form-item label="内容" prop="homPageContent">
    <el-input type="textarea" v-model="addHomePageForm.homPageContent"></el-input>
  </el-form-item>
  <el-form-item label="图片" prop="imageUrl">
<el-upload
  class="avatar-uploader"
  action="https://jsonplaceholder.typicode.com/posts/"
  :show-file-list="false"
  :auto-upload="false"
   accept="image/png,image/gif,image/jpg,image/jpeg"
    :on-change="handleChanges"  
    :on-remove="handleRemoves">
  <img v-if="imageUrl" :src="imageUrl" class="avatar">
  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
</el-upload>

</el-form-item>
  <el-form-item>
  </el-form-item>
</el-form>
  <!-- 底部区域 -->
  <div style="text-align: center;">
    <el-button type="primary" @click="onInsertSubmit">立即添加</el-button>
    <el-button @click="insertHome = false">取 消</el-button>
    <el-button  type="" @click="reset()">重置</el-button>
  </div>
</el-dialog>






<el-dialog
  title="轮播修改"
  :visible.sync="updateHome"
  width="50%"
  :before-close="handleClose"
  center
  >
  <!-- 主体区域 -->
  <el-form ref="addHomePageRef" :model="addHomePageForm" :rules="addHomePageRules" label-width="80px">
  <el-form-item label="标题" prop="homPageTitle">
    <el-input v-model="addHomePageForm.homPageTitle"></el-input>
  </el-form-item>
  <el-form-item label="内容" prop="homPageContent">
    <el-input type="textarea" v-model="addHomePageForm.homPageContent"></el-input>
  </el-form-item>
  <el-form-item label="图片" prop="imageUrl">
<el-upload
  class="avatar-uploader"
  action="https://jsonplaceholder.typicode.com/posts/"
  :show-file-list="false"
  :auto-upload="false"
   accept="image/png,image/gif,image/jpg,image/jpeg"
    :on-change="handleChanges"  
    :on-remove="handleRemoves">
  <img v-if="imageUrl" :src="imageUrl" class="avatar">
  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
</el-upload>

</el-form-item>
  <el-form-item>
  </el-form-item>
</el-form>
  <!-- 底部区域 -->
  <div style="text-align: center;">
    <el-button type="primary" @click="updateSubmit">立即修改</el-button>
    <el-button @click="updateClose">取 消</el-button>
    <el-button  type="" @click="reset()">重置</el-button>
  </div>
</el-dialog>
  </div>
</template>

<script>
export default {
    created(){
        this.getHomePage()
    },
  data(){
    return{
      updateHome:false,
        homeList:[],
    insertHome:false,
    imageUrl:'',
    addHomePageForm:{
    homPageTitle:'',
    homPageContent:'',
    imageUrl:'',
    oldImgUrl:'',
    homPageID:'',
    },
    addHomePageRules:{
  homPageTitle:[
          { required: true, message: '请输标题', trigger: 'blur' },
             { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
      ],
       imageUrl:[
          {required: true, message: '请选择照片', trigger:'change' },
      ],
    },

    }
  },
methods:{
    onInsertSubmit(){
      this.$refs.addHomePageRef.validate(valid=>{
        if(!valid)
        return
 let config = { headers: { "Content-Type": "multipart/form-data" } };    
 this.axios.post("/home/insertHomePage",this.addHomePageForm,config)
          .then(resp => { 
                      if(resp.data.status == 1) {   
                                  this.insertHome=false
                                  this.$refs.addHomePageRef.resetFields()
                                    this.getHomePage()
                                    this.imageUrl=''
                                   this.$message.success(resp.data.result)    
                                }else {
                                  this.$message.error(resp.data.message)                           
                                }
                            })
                            .catch((err) => {
                               alert("出错了")
                                console.log(err)
                            }) 

      })
        
    },updateSubmit(){
               let config = { headers: { "Content-Type": "multipart/form-data" } };    
 this.axios.post("/home/updateHomePage",this.addHomePageForm,config)
          .then(resp => { 
                      if(resp.data.status == 1) {   
                                  this.updateHome=false
                                   this.updateClose()
                                    this.getHomePage()
                                   this.$message.success(resp.data.result)    
                                }else {
                                  this.$message.error(resp.data.message)                           
                                }
                            })
                            .catch((err) => {
                               alert("出错了")
                                console.log(err)
                            }) 
    },
      reset(){
        // this.$refs.addHomePageRef.resetFields()
         this.$refs.addHomePageRef.resetFields()
      },
        handleChanges(file, fileList) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.addHomePageForm.imageUrl=file.raw
      },
      handleRemoves(file, fileList) {
       this.addHomePageForm.imageUrl=''
      }, updatHomePage(data){      
                            this.updateHome=true
                          
this.axios.post("/home/getHomePage?homPageID="+data.homPageID)
          .then(resp => { 
                      if(resp.data.status == 1) {   
                         console.log(resp.data)  
                            this.imageUrl=this.$imagepath+resp.data.result[0].homPageFilePath
                            this.addHomePageForm.oldImgUrl=resp.data.result[0].homPageFilePath
                            this.addHomePageForm.homPageTitle=resp.data.result[0].homPageTitle
                            this.addHomePageForm.homPageContent=resp.data.result[0].homPageContent
                            this.addHomePageForm.homPageID=resp.data.result[0].homPageID
                                }else {
                                  this.$message.error(resp.data.message)                           
                                }
                            })
                            .catch((err) => {
                               alert("出错了")
                                console.log(err)
                            })
                           },
      getHomePage(){
         this.axios.post("/home/getHomePage")
          .then(resp => { 
                      if(resp.data.status == 1) {   
                        this.homeList=resp.data.result
                                }else {
                                    alert("出错")
                                  this.$message.error(resp.data.message)                           
                                }
                            })
                            .catch((err) => {
                               alert("出错了")
                                console.log(err)
                            }) 
      },insertHomes(){
        this.insertHome=true
      },deleteHomePage(data){
        const that=this
        this.$confirm("确定删除？","提示",{
          confirmButtonText: "确认",//确认按钮文字更换
          cancelButtonText: "取消",//取消按钮文字更换
          showClose: true,//是否显示右上角关闭按钮
          type: "warning",//提示类型  success/info/warning/error
      }).then(function(){  
        that.axios.post("/home/deleteHomePage?homPageID="+data.homPageID+"&homPageFilePath="+data.homPageFilePath)
          .then(resp => {
                      if(resp.data.status == 1) {   
                        that.$message.success(resp.data.result)  
                        that.getHomePage()
                                }else {
                                  that.$message.error(resp.data.message)                           
                                }
                            })
                            .catch((err) => {
                               alert("出错了")
                                console.log(err)
                            }) 
      }).catch(()=>{});
      },handleClose(done) {
       this.updateClose()
         done()
      },updateClose(){
         this.addHomePageForm.homPageContent=''
          this.addHomePageForm.homPageTitle=''
           this.addHomePageForm.imageUrl=''
            this.addHomePageForm.oldImgUrl=''
             this.addHomePageForm.homPageID=''
        this.imageUrl=''
        this.updateHome = false
      },HomeShow(data){
        console.log(data)
        this.axios.post("/home/updateIsShow","isShow="+data.isShow+"&id="+data.homPageID)
          .then(resp => { 
                      if(resp.data.status == 1) {                                                                                        
                                  this.$message.success("修改成功")                   
                                                  
                                }else {
                                   alert("拿取数据失败")                             
                                   this.$error.success("修改成功")                   
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            }) 
      }
    
      
}
}
</script>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/work/bam/HomePage.vue